import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Regular } from '@piconetworks/pkg-box';
import ModalContext from './ModalContext.js';
import style from './ModalHeader.module.scss.js';

var _excluded = ["children", "className", "renderCloseButton", "onClose", "scrollable"];
var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
    className = _ref.className,
    renderCloseButton = _ref.renderCloseButton,
    onClose = _ref.onClose,
    scrollable = _ref.scrollable,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var context = React.useContext(ModalContext);
  return /*#__PURE__*/React.createElement(Regular, _extends({
    className: cx(style.modalHeader, scrollable && style.modalHeaderScrollable, className)
  }, props), /*#__PURE__*/React.createElement(Regular, {
    className: style.modalTitle
  }, children), renderCloseButton && /*#__PURE__*/React.cloneElement(renderCloseButton, {
    onClick: function onClick() {
      if (context) return context.onClose();
      if (onClose) return onClose();
    }
  }));
};
ModalHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Show a close button */
  renderCloseButton: PropTypes.any,
  /**
   * A callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onClose will automatically be propagated up to the
   * parent Modal `onClose`.
   */
  onClose: PropTypes.func,
  scrollable: PropTypes.bool
};

export { ModalHeader as default };
//# sourceMappingURL=ModalHeader.js.map
